import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const K_DEVICE = "clockin.kiosk_device"; // device JWT (long-lived, ip-bound)
const K_CTX = "clockin.kiosk_ctx"; // last known device context (tenant/worksite/config)

export function getKioskDeviceToken() {
  return localStorage.getItem(K_DEVICE);
}
export function setKioskDeviceToken(token) {
  if (token) localStorage.setItem(K_DEVICE, token);
  else localStorage.removeItem(K_DEVICE);
}
export function loadKioskCtx() {
  const raw = localStorage.getItem(K_CTX);
  return raw ? JSON.parse(raw) : null;
}
export function saveKioskCtx(ctx) {
  if (ctx) localStorage.setItem(K_CTX, JSON.stringify(ctx));
  else localStorage.removeItem(K_CTX);
}
export function clearKioskDevice() {
  localStorage.removeItem(K_DEVICE);
  localStorage.removeItem(K_CTX);
}

export const kioskApi = axios.create({ baseURL: API });

kioskApi.interceptors.request.use((config) => {
  const token = getKioskDeviceToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

kioskApi.interceptors.response.use(
  (r) => r,
  (error) => {
    // Never auto-refresh a device JWT — the device must re-pair.
    if (error?.response?.status === 401) {
      const url = error.config?.url || "";
      // Business-level 401/423 from PIN-verify (invalid_pin/locked) must NOT nuke the device.
      const isPinBusiness =
        url.includes("/kiosk/pin-verify") &&
        (error.response?.data?.error === "invalid_pin" ||
          error.response?.data?.error === "locked");
      // Don't nuke on /pair failures (bad code) — those are handled per-form.
      const isPairError = url.includes("/kiosk/pair");
      if (!isPinBusiness && !isPairError) {
        clearKioskDevice();
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/kiosk/pair")) {
          window.location.replace("/kiosk/pair");
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatKioskError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Request failed";
  if (typeof d === "string") return d;
  if (d?.error) return d.error;
  return JSON.stringify(d);
}
